"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasNPLAccess = exports.ABSSubMenuLinks = void 0;

var _editions_map = _interopRequireWildcard(require("./editions_map"));

var _URLUtils = require("./URLUtils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Ramda = require('ramda');

var ABS_NPL = _editions_map.PRODUCTS.ABS.id + '.' + '131072';
var EU_CRE = _editions_map.PRODUCTS.ABS.id + '.' + '2048';
var ABS_DEBTWIRE_COM = _editions_map.PRODUCTS.ABS.id + '.' + '512';

var ABSSubMenuLinks = function ABSSubMenuLinks(activePath, entitlements, env) {
  // EUCRE is an exception in term of the URL, it start with aslive-www. istead of aslive. like the rest of legagcy products
  var addPrefixToEUCRE = function addPrefixToEUCRE(env, link) {
    var url = 'http://';

    if (env !== 'live') {
      url = url + env + '-';
    }

    return url + 'www.' + link;
  };

  var BID_LIST_MENU_ITEM = {
    link: 'dwabs.debtwire.com/xbidlists.aspx',
    displayName: 'Bid Lists',
    isLegacy: true
  };
  var EU_CRE_MENU_ITEM = {
    link: addPrefixToEUCRE(env, 'debtwire.com/cre/eu'),
    displayName: 'EU CRE'
  };
  var US_CRE_MENU_ITEM = {
    link: 'dwabs.debtwire.com/CRE/CREList.aspx',
    displayName: 'US CRE',
    isLegacy: true
  };
  var NEW_ISSUES_MENU_ITEM = {
    link: 'dwabs.debtwire.com/xNewIssuesList.aspx',
    displayName: 'New Issues',
    isLegacy: true
  };
  var EUROPEAN_ABS_MENU_ITEM = {
    link: 'abs.debtwire.com/Common/Abs/ABSEU/Default.aspx',
    displayName: 'European ABS',
    isLegacy: true
  };
  var NPL_MENU_ITEM = {
    link: '/non-performing-loans',
    displayName: 'European NPLs',
    active: activePath.indexOf('/non-performing-loans') >= 0
  };
  var ABSSubMenuLinks = [].concat(hasSubscriptionTag(entitlements, ABS_DEBTWIRE_COM) ? BID_LIST_MENU_ITEM : []).concat(hasSubscriptionTag(entitlements, EU_CRE) ? EU_CRE_MENU_ITEM : []).concat(hasSubscriptionTag(entitlements, ABS_DEBTWIRE_COM) ? US_CRE_MENU_ITEM : []).concat(hasSubscriptionTag(entitlements, ABS_DEBTWIRE_COM) ? NEW_ISSUES_MENU_ITEM : []).concat(hasSubscriptionTag(entitlements, ABS_DEBTWIRE_COM) ? EUROPEAN_ABS_MENU_ITEM : []).concat(hasNPLAccess(entitlements) ? NPL_MENU_ITEM : []).map((0, _URLUtils.prefixEnv)(env.toLowerCase())).map(_URLUtils.prefixHttp);
  return ABSSubMenuLinks;
};

exports.ABSSubMenuLinks = ABSSubMenuLinks;

var hasEntitlementTag = function hasEntitlementTag(entitlements, entitlement) {
  return entitlements.Tags && Ramda.filter(Boolean, entitlements.Tags.map(function (tag) {
    return tag.Key === entitlement;
  })).length !== 0;
};

var hasSubscriptionTag = function hasSubscriptionTag(entitlements, subscriptionTag) {
  return entitlements.SubscriptionTags && Ramda.filter(Boolean, entitlements.SubscriptionTags.map(function (tag) {
    return tag.Key === subscriptionTag;
  })).length !== 0;
};

var hasNPLAccess = function hasNPLAccess(entitlements) {
  return hasEntitlementTag(entitlements, _editions_map["default"].ABS_EUROPE.id) && hasSubscriptionTag(entitlements, ABS_NPL);
};

exports.hasNPLAccess = hasNPLAccess;